import { FC, useEffect, useState } from 'react'

import { utils } from '../../../utils'
import { Button, Checkbox, Icon, Table, TableLabel, Text, Textarea } from '../../UI'

type RequestedBudgetDocumentsProps = {
  data: any,
}

const RequestedBudgetDocuments:FC<RequestedBudgetDocumentsProps> = ({ data }) => {
  const [documents, setDocuments] = useState<any[]>([])
  const [documentsAllSel, setDocumentsAllSel] = useState<boolean>(false)
  const [documentsSel, setDocumentsSel] = useState<any[]>([])

  useEffect(() => {
    setDocuments(getDocuments(data.documentos_files, data.ID))
  }, [data])

  const tableDocumentsColumns = [
    {
      accessor: 'id',
      Header: () => {
        return (
          <>
            <Checkbox
              id="tableDocAll"
              checked={documentsAllSel}
              onChange={onDocumentsAllSel}
            />
            <label htmlFor="tableDocAll" className="fz-0">&nbsp;</label>
          </>
        )
      },
      width: '10%',
      Cell: (params: any) => {
        const { values } = params.row
        const checkId = `check-${values.id}`

        return (
          <>
            <Checkbox
              id={checkId}
              name={checkId}
              checked={documentsSel ? isDocumentSel(values.id) : false}
              onChange={(event) => onDocumentSel(event, values)}
            />
            <label htmlFor={checkId} className="fz-0">&nbsp;</label>
          </>
        )
      }
    },
    {
      accessor: 'name',
      Header: 'Documentos',
      width: '55%'
    },
    {
      accessor: 'url',
      Header: 'Ver / Descargar',
      width: '35%',
      Cell: (params: any) => {
        const { value, row } = params

        return (
          <div className="text-center">
            <a href={value} target="_blank" rel="noreferrer">
              <Icon name="view" color={documentsSel && isDocumentSel(row.values?.id) ? 'primary' : ''} />
            </a>
          </div>
        )
      }
    }
  ]

  const getDocuments = (documents: any[], id: string) => {
    if(documents && documents.length) {
      const aDocs = documents.map((url: string, i: number) => {
        const aUrl: any[] = (url ? url.split('/') : [])
        const name: string = (aUrl.length ? aUrl[aUrl.length - 1] : '')
        const ids = `${id}${i}`

        return {
          id: ids,
          name,
          url
        }
      })

      return aDocs
    } else {
      return []
    }
  }

  const isDocumentSel = (id: number) => documentsSel.find((it: any) => it.id === id)

  const onDocumentSel = (event: any, doc: any) => {
    const { checked } = event.target
    const { id } = doc

    if(checked) {
      if(!isDocumentSel(id)) {
        setDocumentsSel(
          [
            ...documentsSel,
            doc
          ]
        )
      }
    } else {
      setDocumentsSel(documentsSel.filter((it: any) => it.id !== id))
      setDocumentsAllSel(false)
    }
  }

  const onDocumentsAllSel = (event: any) => {
    const { checked } = event.target

    setDocumentsAllSel(checked)

    if(checked) {
      setDocumentsSel(documents)
    } else {
      setDocumentsSel([])
    }
  }

  const onDocumentsDownload = async () => {
    if(documentsSel && documentsSel.length) {
      documentsSel.forEach((doc: any) => {
        fetch(doc.url/* , { method: 'GET', mode: 'no-cors' } */).then((resp1: any) => {
          return resp1.blob().then((resp2: any) => {
            setTimeout(() => {
              var a = document.createElement('a')
              a.href = URL.createObjectURL(resp2)
              a.setAttribute('download', doc.name)
              a.click()
            }, 500)
          })
        })
      })
    }
  }

  return (
    <div className="pt-50 pb-30 px-20 lg:px-40">
      <fieldset>
        <TableLabel>Tipo de intervención</TableLabel>
        <Text size="16" className="mt-5">{data.tipo_intervencion?.nombre}</Text>
      </fieldset>

      <fieldset className="mt-10">
        <TableLabel>Médico tratante</TableLabel>
        <Text size="16" className="mt-5">{data.medico_tratante}</Text>
      </fieldset>

      <fieldset className="mt-10">
        <TableLabel>Fecha de solicitud</TableLabel>
        <Text size="16" className="mt-5">{utils.getDateFormat(data.fecha_recepcion, 'DD/MM/YYYY')}</Text>
      </fieldset>

      <fieldset className="mt-10">
        <Text size="16">Nota:</Text>
        <Textarea
          version="2"
          rows={10} fullWidth
          defaultValue={data.comentario_ejecutivo}
          readOnly
          className="mt-5"
          style={{ minHeight: '100px' }}
        ></Textarea>
      </fieldset>

      {documents && documents.length > 0 &&
        <>
          <fieldset className="mt-20">
            <Table
              columns={tableDocumentsColumns}
              data={documents}
            />
          </fieldset>

          <fieldset className="text-center mt-20">
            <Button size="md" onClick={onDocumentsDownload}>
              Descargar seleccionados<Icon name="download" className="ml-10" />
            </Button>
          </fieldset>
        </>
      }
    </div>
  )
}

export { RequestedBudgetDocuments }